module.exports = __webpack_public_path__ + "static/img/WechatIMG114.b67e7a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WechatIMG114.png
// module id = tC/0
// module chunks = 1